<template>
  <div class="news-table w-100">
    <h3 class="mb-3">{{ $t("heading") }}</h3>
    <nx-table class="esh-bd-table mt-3" style="text-align: justify;white-space: break-spaces;" :rows="newsList">
      <nx-table-column
        :title="$t('table.date')"
        data="date"
        v-slot="{ rowData }"
        width="200"
      >
        {{ dateFormatter(rowData.date) }}
      </nx-table-column>
      <nx-table-column
        :title="$t('table.content')"
        data="content"
        v-slot="{ rowData }"
      >
        <span >{{rowData.content}}</span>
      </nx-table-column>
    </nx-table>
    <UFPaginationNav :pagination="pagination" @navigate="updateList($event)" />
  </div>
</template>
@row-clicked="rowClicked"
<script>
import {
  UFPagination,
  UFPaginationNav,
  UFPaginationProvider
} from '@unify/uf-pagination';
import { MaintainNewsApi } from '@/api';

export default {
  components: {
    UFPagination,
    UFPaginationNav,
    UFPaginationProvider,
  },
  data() {
    return {
      newsList: [],
      pagination: {
        page: 0,
        size: 15,
        sort: 'date desc'
      }
    };
  },
  async created() {
    await this.updateList();
  },
  watch: {
    '$i18n.locale': {
      handler() {
        this.updateList();
      }
    }
  },
  methods: {
    // rowClicked(r) {
    //   window.open(r.data.link);
    // }
    async updateList(pageable) {
      // console.log('accept emit update');
      const { data: newsList } = await MaintainNewsApi.getLatestNewstList(
        pageable || this.pagination
      );
      this.newsList = newsList.content;
      this.pagination = newsList.pagination;
      // console.log("this.$i18n",this.$i18n)
    
      if (this.$i18n.locale == 'zh_hk') {
        this.newsList = this.newsList.filter(row => row.language == 'zh_hk' )
      }
      else if (this.$i18n.locale == 'zh_cn') {
        this.newsList = this.newsList.filter(row => row.language == 'zh_cn' )
      }
      else {
        this.newsList = this.newsList.filter(row => row.language == 'en' )
      }
    },
    dateFormatter(date) {
      switch(this.$i18n.locale){
        case "en": 
          return moment(date).format('DD MMM YYYY');
        case "zh_hk": 
          return moment(date).locale('zh_hk').format('LL');
        case "zh_cn": 
          return moment(date).locale('zh_cn').format('LL');
        default: 
          return moment(date).format('DD MMM YYYY');
      }
    },
  },
};
</script>

<style lang="scss"></style>

<i18n src="@/locales/common.locale"></i18n>

<i18n src="@/locales/components/info/InfoNewsTable.json"></i18n>